import {queryToObject} from '../../../utils/queryParams'

import type {PluginLocationContext} from './Plugin.types'

export const getPluginUIContext = (activeEntities: PluginLocationContext): string =>
  JSON.stringify(activeEntities)
export function getActiveEntitiesFromUrl(): PluginLocationContext {
  const {projectId, buildId, buildTypeId, agentId, agentPoolId, agentTypeId} = queryToObject(
    document.location.search,
  )
  return {
    projectId,
    buildId,
    buildTypeId,
    agentId,
    agentPoolId,
    agentTypeId,
  }
}
